import React, { useState } from "react";
import { Card, Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";

const TranslationFilters = ({
                              fields = {},
                              defaultFilters = [],
                              handleSearch,
                              totalCount
                            }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);

  const handleChangeFilter = (name, valueObject) => {
    let result = [];
    const index = filters.findIndex(filter => filter.fieldName === name);
    if (index === -1) {
      valueObject.searchOperation = filterTypes.LIKE.value;
      result = [...filters, valueObject];
    } else if (!Object.keys(valueObject).length) {
      result = filters.filter(o => o.fieldName !== name);
    } else {
      result = [...filters];
      result[index] = valueObject;
    }
    setFilters(result);
  };

  const handleSubmit = () => {
    setIsOpen(false);
    handleSearch(filters);
  };

  const handleReset = () => {
    setIsOpen(false);
    setFilters([]);
    handleSearch([]);
  };

  return (
    <Card className="w-100 mb-2 rounded-0">
      <FilterHeader
        title={(
          <div>
            Translations
            <Link
              to="/translation/create"
              className="btn btn-success btn-sm ml-2"
              title="Create new translation"
            >
              <FontAwesomeIcon icon={faPlus}/>
            </Link>
          </div>
        )}
        totalCount={totalCount}
        isOpen={isOpen}
        onToggle={(status) => setIsOpen(status)}
      />
      <Card.Body className="p-0">
        <Collapse in={isOpen} className="p-2" timeout={0}>
          <div className="row">
            {Object.keys(fields)
              .map(key => (
                <div key={key} className="col-12 col-md-3 mb-3">
                  <FilterItem
                    name={key}
                    placeholder={fields[key].placeholder || key}
                    filterType={fields[key].filterType}
                    defaultValue={fields[key].defaultValue || ""}
                    onChange={handleChangeFilter}
                    filterTypeOptions={fields[key].filterTypeOptions || []}
                    exitsTypeOptions={fields[key].exitsTypeOptions || []}
                    searchOperation={[filterTypes.LIKE.value]}
                    value={findFilterValue(key, filters)}
                  />
                </div>
              ))}
            <div className="col-12 col-md-3 mb-2">
              <div
                className="d-flex justify-content-between justify-content-md-end">
                <button
                  className="btn btn-warning btn-sm ml-2"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="btn btn-success btn-sm ml-2"
                  onClick={handleSubmit}
                >
                  Load
                </button>
              </div>
            </div>
          </div>
        </Collapse>
      </Card.Body>
    </Card>
  );
};

export default TranslationFilters;



// WEBPACK FOOTER //
// ./src/views/pages/Translation/filters.js